"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
};
var __changes, __doc;
var Pile_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pile = void 0;
const calculator_1 = require("./calculator");
const decorators_1 = require("./decorators");
const regex_1 = require("./regex");
const util_1 = require("./util");
let Pile = Pile_1 = class Pile {
    constructor(doc) {
        __changes.set(this, { measures: false, position: false });
        __doc.set(this, void 0);
        __classPrivateFieldSet(this, __doc, doc);
    }
    static create(sectorUID, uid, data) {
        var _a, _b, _c;
        const numericIdMatch = uid.match(regex_1.pileNumberRegex);
        if (numericIdMatch === null || (numericIdMatch && !numericIdMatch[1])) {
            throw new Error('Invalid pile UID, has no numeric component');
        }
        let measures, essence, position;
        if (data) {
            if (data.measures) {
                measures = data.measures;
            }
            if (data.position) {
                position = data.position;
            }
            if (data.essence) {
                essence = data.essence;
            }
        }
        const doc = {
            _id: uid,
            id: numericIdMatch[1],
            sector: sectorUID,
            created: ((_a = data === null || data === void 0 ? void 0 : data.created) === null || _a === void 0 ? void 0 : _a.toISOString()) || new Date().toISOString(),
            operation: data === null || data === void 0 ? void 0 : data.operation,
            road: data === null || data === void 0 ? void 0 : data.road,
            team: data === null || data === void 0 ? void 0 : data.team,
            foreman: data === null || data === void 0 ? void 0 : data.foreman,
            status: (data === null || data === void 0 ? void 0 : data.status) || 'new',
            measures,
            essence,
            position,
            modified: (_b = data === null || data === void 0 ? void 0 : data.modified) === null || _b === void 0 ? void 0 : _b.toISOString(),
            transported: (_c = data === null || data === void 0 ? void 0 : data.transported) === null || _c === void 0 ? void 0 : _c.toISOString(),
            history: [],
            meta: {}
        };
        return new Pile_1(doc);
    }
    get uid() {
        return __classPrivateFieldGet(this, __doc)._id;
    }
    set uid(value) {
        if (!regex_1.pileKeyRegex.test(value)) {
            throw new Error(`${value} is not a valid PileUID`);
        }
        __classPrivateFieldGet(this, __doc)._id = value;
    }
    get extremity() {
        return __classPrivateFieldGet(this, __doc).extremity ? true : false;
    }
    set extremity(value) {
        __classPrivateFieldGet(this, __doc).extremity = value;
    }
    get id() {
        return __classPrivateFieldGet(this, __doc)._id.replace(/s\:[^\:]+\:p\:/, '');
    }
    get sector() {
        return __classPrivateFieldGet(this, __doc).sector;
    }
    set sector(value) {
        if (!regex_1.sectorKeyRegex.test(value)) {
            throw new Error(`${value} is not a valid SectorUID`);
        }
        __classPrivateFieldGet(this, __doc).sector = value;
    }
    get essence() {
        return __classPrivateFieldGet(this, __doc).essence;
    }
    set essence(value) {
        __classPrivateFieldGet(this, __doc).essence = value;
    }
    get operation() {
        return __classPrivateFieldGet(this, __doc).operation;
    }
    set operation(value) {
        __classPrivateFieldGet(this, __doc).operation = value;
    }
    get road() {
        return __classPrivateFieldGet(this, __doc).road;
    }
    set road(value) {
        __classPrivateFieldGet(this, __doc).road = value;
    }
    get team() {
        return __classPrivateFieldGet(this, __doc).team;
    }
    set team(value) {
        __classPrivateFieldGet(this, __doc).team = value;
    }
    get foreman() {
        return __classPrivateFieldGet(this, __doc).foreman;
    }
    set foreman(value) {
        __classPrivateFieldGet(this, __doc).foreman = value;
    }
    get measures() {
        return Object.assign({
            length: undefined,
            heights: [],
            logLength: undefined
        }, __classPrivateFieldGet(this, __doc).measures);
    }
    set measures(value) {
        value = Object.assign(Object.assign({}, __classPrivateFieldGet(this, __doc).measures), value);
        __classPrivateFieldGet(this, __doc).measures = value;
        __classPrivateFieldGet(this, __changes).measures = true;
    }
    get position() {
        return Object.assign({
            latitude: undefined,
            longitude: undefined,
            altitude: undefined
        }, __classPrivateFieldGet(this, __doc).position);
    }
    set position(value) {
        value = Object.assign(Object.assign({}, __classPrivateFieldGet(this, __doc).position), value);
        __classPrivateFieldGet(this, __doc).position = value;
        __classPrivateFieldGet(this, __changes).position = true;
    }
    get created() {
        if (!__classPrivateFieldGet(this, __doc).created) {
            __classPrivateFieldGet(this, __doc).created = (new Date()).toISOString();
        }
        return new Date(__classPrivateFieldGet(this, __doc).created);
    }
    set created(value) {
        if (typeof value == 'string') {
            value = (new Date(value)).toISOString();
        }
        __classPrivateFieldGet(this, __doc).created = value;
    }
    get modified() {
        if (!__classPrivateFieldGet(this, __doc).modified) {
            return undefined;
        }
        return new Date(__classPrivateFieldGet(this, __doc).modified);
    }
    set modified(value) {
        if (typeof value == 'string') {
            value = (new Date(value)).toISOString();
        }
        else if (!value) {
            return;
        }
        __classPrivateFieldGet(this, __doc).modified = value;
    }
    get transported() {
        if (!__classPrivateFieldGet(this, __doc).transported) {
            return undefined;
        }
        return new Date(__classPrivateFieldGet(this, __doc).transported);
    }
    set transported(value) {
        if (typeof value == 'string') {
            value = (new Date(value)).toISOString();
        }
        else if (!value) {
            return;
        }
        __classPrivateFieldGet(this, __doc).transported = value;
    }
    get status() {
        return __classPrivateFieldGet(this, __doc).status || 'new';
    }
    set status(value) {
        __classPrivateFieldGet(this, __doc).status = value;
    }
    get history() {
        return (__classPrivateFieldGet(this, __doc).history || []).map(util_1.deserializePileHistoryItem);
    }
    get timeline() {
        const history = this.history;
        return history.reduce((l, h) => {
            let time;
            switch (h.status) {
                case 'modified':
                    time = h.modified;
                    break;
                case 'transported':
                    time = h.transported;
                    break;
                case 'new':
                case 'inventory':
                default:
                    time = h.created;
                    break;
            }
            ;
            const data = calculator_1.expandMeasures(h.measures);
            Object.assign(data, { status: h.status });
            l.push({ time: time, data: data });
            return l;
        }, []);
    }
    get meta() {
        return Object.assign({}, __classPrivateFieldGet(this, __doc).meta);
    }
    set meta(value) {
        const current = __classPrivateFieldGet(this, __doc).meta || {};
        const meta = Object.assign(Object.assign({}, current), value);
        for (let propName in meta) {
            if (meta[propName] === null || meta[propName] === undefined) {
                delete meta[propName];
            }
        }
        __classPrivateFieldGet(this, __doc).meta = meta;
    }
    // non enumerable getters for convenience
    get height() {
        const { measures } = this;
        const { heights } = measures;
        if (heights.length == 0) {
            return 0;
        }
        if (heights.length == 1) {
            return heights[0];
        }
        return Number((heights.reduce(util_1.sum) / heights.length).toFixed(2));
    }
    get essenceName() {
        var _a;
        return (_a = this.essence) === null || _a === void 0 ? void 0 : _a.name;
    }
    get essenceCode() {
        var _a;
        return (_a = this.essence) === null || _a === void 0 ? void 0 : _a.code;
    }
    get length() {
        const { measures } = this;
        return measures.length || 0;
    }
    get factor() {
        return calculator_1.getPileFactor(this);
    }
    get volume() {
        return calculator_1.calculatePileVolume(this);
    }
    get logLength() {
        const { measures } = this;
        return measures.logLength || 0;
    }
    get hasMeasures() {
        const { measures } = this;
        const { heights, length, logLength } = measures;
        const hasHeight = heights && heights.length > 0;
        const hasLength = !!length;
        const hasLogLength = !!logLength;
        const hasMeasures = hasHeight && hasLength && hasLogLength;
        return hasMeasures;
    }
    get hasPosition() {
        const { position } = this;
        return !!position.latitude && !!position.longitude;
    }
    get hasChanges() {
        return Object.keys(__classPrivateFieldGet(this, __changes)).some((key) => {
            return __classPrivateFieldGet(this, __changes)[key];
        });
    }
    get measuresChanged() {
        return !!__classPrivateFieldGet(this, __changes).measures;
    }
    get positionChanged() {
        return !!__classPrivateFieldGet(this, __changes).position;
    }
    addHeight(height) {
        const { measures } = this;
        const { heights } = measures;
        heights.push(height);
        measures.heights = heights;
        this.measures = measures;
    }
    removeHeight(index) {
        const { measures } = this;
        const { heights } = measures;
        heights.splice(index, 1);
        measures.heights = heights;
        this.measures = measures;
    }
    clone() {
        return new Pile_1(this.toDoc());
    }
    toHistoryItem() {
        return util_1.serializePileHistoryItem(this);
    }
    toDoc() {
        return Object.assign({
            measures: this.measures,
            position: this.position
        }, __classPrivateFieldGet(this, __doc));
    }
    toJSON() {
        var _a, _b;
        const jsonObj = {};
        // add all properties
        const proto = Object.getPrototypeOf(this);
        for (const key of Object.keys(proto)) {
            const desc = Object.getOwnPropertyDescriptor(proto, key);
            const hasGetter = desc && typeof desc.get === 'function';
            if (hasGetter) {
                if (['created', 'modified', 'transported'].includes(key)) {
                    const value = (_a = desc === null || desc === void 0 ? void 0 : desc.get) === null || _a === void 0 ? void 0 : _a.call(this);
                    if (value) {
                        jsonObj[key] = new Date(value).toISOString();
                    }
                    else {
                        jsonObj[key] = value;
                    }
                }
                else {
                    jsonObj[key] = (_b = desc === null || desc === void 0 ? void 0 : desc.get) === null || _b === void 0 ? void 0 : _b.call(this);
                }
            }
        }
        return jsonObj;
    }
};
__changes = new WeakMap(), __doc = new WeakMap();
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Pile.prototype, "uid", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], Pile.prototype, "extremity", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], Pile.prototype, "id", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Pile.prototype, "sector", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Pile.prototype, "essence", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Pile.prototype, "operation", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Pile.prototype, "road", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Pile.prototype, "team", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Pile.prototype, "foreman", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Pile.prototype, "measures", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Pile.prototype, "position", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Pile.prototype, "created", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Pile.prototype, "modified", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Pile.prototype, "transported", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Pile.prototype, "status", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], Pile.prototype, "history", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Pile.prototype, "timeline", null);
__decorate([
    decorators_1.Enumerable(true),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], Pile.prototype, "meta", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], Pile.prototype, "height", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], Pile.prototype, "essenceName", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [])
], Pile.prototype, "essenceCode", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], Pile.prototype, "length", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Pile.prototype, "factor", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], Pile.prototype, "volume", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Number),
    __metadata("design:paramtypes", [])
], Pile.prototype, "logLength", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Pile.prototype, "hasMeasures", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Pile.prototype, "hasPosition", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Pile.prototype, "hasChanges", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Pile.prototype, "measuresChanged", null);
__decorate([
    decorators_1.Enumerable(false),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [])
], Pile.prototype, "positionChanged", null);
Pile = Pile_1 = __decorate([
    decorators_1.Sealed(),
    __metadata("design:paramtypes", [Object])
], Pile);
exports.Pile = Pile;
